import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const Overview = lazy(() =>
  import("@scenes/Overview/OverviewNRO").then((module) => ({
    default: module.OverviewNRO,
  }))
);

export const dashboardAppUsageNRO: NavigationRoutingObject = {
  Component: Overview,
  componentFeatureFlippers: ["dashboard_app_usage_nro_component"],
  section: "analytics",
  heading: (t: I18nT<"dashboard-navigation">) => t("dashboard-app-usage-nro-heading", "Performance Overview"),
  pageNameForTracking: () => "Performance Overview",
  getDeveloperNavigationAllowed: () => true,
  additionalSearchTerms: (t: I18nT<"dashboard-navigation">) => [
    {
      keywords: [
        t("dashboard-app-usage-nro-alt-keyword-1", "app usage"),
        t("dashboard-app-usage-nro-alt-keyword-2", "home page"),
        t("dashboard-app-usage-nro-alt-keyword-3", "users"),
        t("dashboard-app-usage-nro-alt-keyword-4", "MAU"),
        t("dashboard-app-usage-nro-alt-keyword-5", "lifetime sessions"),
        t("dashboard-app-usage-nro-alt-keyword-6", "monthly active users"),
        t("dashboard-app-usage-nro-alt-keyword-7", "daily active users"),
        t("dashboard-app-usage-nro-alt-keyword-8", "new users"),
        t("dashboard-app-usage-nro-alt-keyword-9", "stickiness"),
        t("dashboard-app-usage-nro-alt-keyword-10", "daily sessions"),
      ],
    },
  ],
  additionalSearchableFeatures: () => ({}),
  defaultRoute: "/dashboard/app_usage/:appGroupId",
};
